export enum PreviewAction {
  compile = 'compile',
  refresh = 'refresh'
}
